import { createSelector } from 'reselect'
import { getArgN } from './utils'

export const _getAll = state => state.processes

/**
 * Get process by ID
 */

export const get = createSelector([ _getAll, getArgN(1) ], (processes, processID) => {
  if (!processID) throw new Error(`Missing processID: ${processID} (${typeof processID})`)
  return processes[processID]
})

/**
 * List of processes.
 */

export const getAll = createSelector([ _getAll ], (processes) => {
  return Object.values(processes).sort((a, b) => {
    if (!b.modifiedAt) return 1
    if (!a.modifiedAt) return -1
    return new Date(b.modifiedAt) - new Date(a.modifiedAt)
  })
})

export const getAllForSample = createSelector([ getAll, getArgN(1) ], (processes, sampleID) => {
  return processes.filter(p => p.sample === sampleID)
})

export const getTemplates = createSelector([ getAll ], processes => (
  processes.filter(p => p.isTemplate)
))



// WEBPACK FOOTER //
// ../webmango-core/selectors/process.js